import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/ParejasTorneoAdmin.css";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

export default function ParejasTorneoAdmin() {
  const { token } = useAuth();
  const { torneoId } = useParams();
  const navigate = useNavigate();
  const [parejas, setParejas] = useState([]);
  const [error, setError] = useState("");

useEffect(() => {
  api
    .get(`/parejas/${torneoId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      const parejasConPuntos = res.data
        .map((pareja) => ({
          ...pareja,
          puntosTotales: (pareja.jugador1_puntos || 0) + (pareja.jugador2_puntos || 0),
          fechasSeleccionadas: [
            { fecha: pareja.fecha_seleccionada?.split("T")[0], horario: pareja.horario1 },
            { fecha: pareja.fecha_seleccionada2?.split("T")[0], horario: pareja.horario2 },
          ],
        }))
        .sort((a, b) => b.puntosTotales - a.puntosTotales); // Ordenar de mayor a menor puntos
      setParejas(parejasConPuntos);
    })
    .catch((err) => {
      console.error("Error al cargar las parejas inscritas:", err);
      setError("Error al cargar las parejas inscritas.");
    });
}, [torneoId, token]);

  

  const confirmarPareja = async (parejaId) => {
    try {
      await api.post(`/parejas/${parejaId}/confirmar`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setParejas((prev) =>
        prev.map((pareja) =>
          pareja.inscripcion_id === parejaId
            ? { ...pareja, confirmada: true }
            : pareja
        )
      );
      Swal.fire({
        title: "Pareja confirmada",
        text: "La pareja ha sido confirmada exitosamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
      });
    } catch (err) {
      console.error("Error al confirmar pareja:", err);
      setError("Error al confirmar pareja.");
      Swal.fire({
        title: "Error",
        text: "Hubo un problema al confirmar la pareja.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const eliminarPareja = async (parejaId) => {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esta acción.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    try {
      await api.delete(`/parejas/${parejaId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setParejas((prev) => prev.filter((pareja) => pareja.inscripcion_id !== parejaId));
      Swal.fire({
        title: "Pareja eliminada",
        text: "La pareja ha sido eliminada exitosamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
      });
    } catch (err) {
      console.error("Error al eliminar pareja:", err);
      setError("Error al eliminar pareja.");
      Swal.fire({
        title: "Error",
        text: "Hubo un problema al eliminar la pareja.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  

  const exportarExcel = () => {
  const datos = parejas.map((pareja) => ({
    "Jugador 1": pareja.jugador1_nombre,
    "Puntos Jugador 1": pareja.jugador1_puntos || 0,
    "Jugador 2": pareja.jugador2_nombre,
    "Puntos Jugador 2": pareja.jugador2_puntos || 0,
    "Puntos Pareja": pareja.puntosTotales,
    "Fechas y Horarios": pareja.fechasSeleccionadas
      ?.map((fecha) => `${fecha.fecha}: ${fecha.horario}`)
      .join(", "),
    Confirmada: pareja.confirmada ? "Sí" : "No",
  }));

  const hoja = XLSX.utils.json_to_sheet(datos);
  const libro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, hoja, "Parejas");

  XLSX.writeFile(libro, `parejas_torneo_${torneoId}.xlsx`);
};

  // Filtrar parejas en dos listas
  const pendientes = parejas.filter((pareja) => !pareja.confirmada);
  const confirmadas = parejas.filter((pareja) => pareja.confirmada);

  return (
    <div className="parejas-torneo-container">
      <h2>Parejas Inscriptas</h2>
      {error && <p className="error-message">{error}</p>}

      <button onClick={exportarExcel} style={{ marginBottom: "1rem" }}>
        Exportar a Excel
      </button>

      {/* Sección de pendientes */}
      <h3>Pendientes de Confirmación</h3>
      {pendientes.length === 0 ? (
        <p>No hay parejas pendientes de confirmación.</p>
      ) : (
        <table>
  <thead>
    <tr>
      <th>#</th>
      <th>Jugador 1</th>
      <th>Puntos Jugador 1</th>
      <th>Jugador 2</th>
      <th>Puntos Jugador 2</th>
      <th>Puntos Pareja</th>
      <th>Fechas y Horarios</th>
      <th>Acciones</th>
    </tr>
  </thead>
  <tbody>
    {pendientes.map((pareja, index) => (
      <tr key={pareja.inscripcion_id}>
        <td>{index + 1}</td>
        <td>{pareja.jugador1_nombre}</td>
        <td>{pareja.jugador1_puntos}</td>
        <td>{pareja.jugador2_nombre}</td>
        <td>{pareja.jugador2_puntos}</td>
        <td>{pareja.puntosTotales}</td>
        <td>
          {pareja.fechasSeleccionadas?.map((fecha, i) => (
            <div key={i}>
              {fecha.fecha}: {fecha.horario}
            </div>
          ))}
        </td>
        <td>
          <button onClick={() => confirmarPareja(pareja.inscripcion_id)}>
            Confirmar
          </button>
          <button className="delete-btn" onClick={() => eliminarPareja(pareja.inscripcion_id)}>
            Eliminar
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>
      )}

      {/* Sección de confirmadas */}
      <h3>Parejas Confirmadas</h3>
      {confirmadas.length === 0 ? (
        <p>No hay parejas confirmadas.</p>
      ) : (
        <table>
  <thead>
    <tr>
      <th>#</th>
      <th>Jugador 1</th>
      <th>Puntos Jugador 1</th>
      <th>Jugador 2</th>
      <th>Puntos Jugador 2</th>
      <th>Puntos Pareja</th>
      <th>Fechas y Horarios</th>
    </tr>
  </thead>
  <tbody>
    {confirmadas.map((pareja, index) => (
      <tr key={pareja.inscripcion_id}>
        <td>{index + 1}</td>
        <td>{pareja.jugador1_nombre}</td>
        <td>{pareja.jugador1_puntos}</td>
        <td>{pareja.jugador2_nombre}</td>
        <td>{pareja.jugador2_puntos}</td>
        <td>{pareja.puntosTotales}</td>
        <td>
          {pareja.fechasSeleccionadas?.map((fecha, i) => (
            <div key={i}>
              {fecha.fecha}: {fecha.horario}
            </div>
          ))}
        </td>
      </tr>
    ))}
  </tbody>
</table>
      )}

      <button onClick={() => navigate(-1)} style={{ marginTop: "1rem" }}>
        Volver atrás
      </button>
    </div>
  );
}